import script from "./CardTank.vue?vue&type=script&setup=true&lang=js"
export * from "./CardTank.vue?vue&type=script&setup=true&lang=js"

import "./CardTank.vue?vue&type=style&index=0&id=5b0eb8e5&scoped=true&lang=css"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b0eb8e5"]])

export default __exports__